import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as ViewActions from "./actions";
import type { ViewReducerState } from "./types";

export type ViewAction = ActionType<typeof ViewActions>;

const initialState: ViewReducerState = {
  displayFlyout: false,
  appStructureNode: null,
  syncNode: null
};

export default function viewReducer(state = initialState, action: ViewAction): ViewReducerState {
  switch (action.type) {
    case getType(ViewActions.toggleFlyout): {
      const isSameMenu = action.payload.appStructureNode?.id === state.appStructureNode?.id;

      if (state.displayFlyout && isSameMenu) {
        return { ...state, displayFlyout: false, appStructureNode: null };
      } else {
        return {
          ...state,
          displayFlyout: true,
          appStructureNode: action.payload.appStructureNode
        };
      }
    }

    case getType(ViewActions.closeFlyout): {
      return {
        ...state,
        displayFlyout: false,
        appStructureNode: null
      };
    }

    case getType(ViewActions.syncNestedFlyoutNodesWithMobile): {
      return {
        ...state,
        syncNode: action.payload.syncNode
      };
    }

    default:
      return state;
  }
}
